import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useLang } from "../i18n";
import { getObiCategory } from "../lib/api";
import { OBI } from "../assets/obi";

const ObiCategoryBanner = ({ categoryId }) => {
  const { lang, t } = useLang();
  const [intro, setIntro] = useState(null);
  const [name, setName] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!categoryId) {
      setIntro(null);
      setName(null);
      return;
    }
    setLoading(true);
    getObiCategory(categoryId, lang)
      .then((r) => {
        setIntro(r.intro);
        setName(r.category_name);
      })
      .catch(() => {
        setIntro(null);
        setName(null);
      })
      .finally(() => setLoading(false));
  }, [categoryId, lang]);

  if (!categoryId) return null;

  return (
    <div
      data-testid="obi-category-banner"
      className="cartoon-card bg-yellow-100 p-5 lg:p-6 mb-8 flex flex-col sm:flex-row items-center sm:items-start gap-4"
    >
      <img
        src={OBI.dice}
        alt="OBI"
        className="w-20 h-20 lg:w-24 lg:h-24 object-contain shrink-0"
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap mb-1">
          <span className="bg-pink-400 border-2 border-slate-900 rounded-full px-2.5 py-0.5 text-xs font-bold">
            ★ {t("home.obi_badge")}
          </span>
          {name && (
            <h3 className="font-display font-bold text-lg lg:text-xl text-slate-900">
              OBI {lang === "it" ? "presenta" : "presents"}: {name}
            </h3>
          )}
        </div>
        {loading ? (
          <div className="flex items-center gap-2 text-sm text-slate-600 italic">
            <Loader2 className="w-4 h-4 animate-spin" /> {t("home.obi_loading")}
          </div>
        ) : intro ? (
          <p className="text-slate-800 italic leading-relaxed">“{intro}”</p>
        ) : null}
      </div>
    </div>
  );
};

export default ObiCategoryBanner;
